import { ReactNode, useEffect, useRef, useState } from 'react'

interface IProps {
  containerClasses?: string
  clearClasses?: string
  fileType?: string
  multiple?: boolean
  children: ReactNode
  clearChildren: ReactNode
  onChangeCallback: (data: any) => void
}

export const FileSelect = ({
  containerClasses = '',
  clearClasses = '',
  fileType = '.csv',
  multiple = false,
  children,
  clearChildren,
  onChangeCallback
}: IProps) => {
  const inputFileRef = useRef<any>(null)
  const [files, setFiles] = useState<File[]>([])

  const activateFileSelect = () => {
    inputFileRef?.current?.click()
  }

  const clear = () => {
    if (inputFileRef?.current) {
      inputFileRef.current.value = ''
    }
    setFiles([])
  }

  const onFileChange = (e: any) => {
    const targetFiles: File[] = Array.from(e.target.files)

    if (targetFiles?.length > 0) {
      setFiles(targetFiles)
    }
  }

  useEffect(() => {
    if (files.length > 0) {
      if (!multiple) {
        onChangeCallback(files[0])
      } else {
        onChangeCallback(files)
      }

      return
    }

    onChangeCallback(null)
  }, [files])

  return (
    <div>
      <div className='relative inline-block'>
        <button type='button' className={clearClasses} onClick={clear}>
          {clearChildren}
        </button>
        <button type='button' className={containerClasses} onClick={activateFileSelect}>
          {children}
        </button>
      </div>
      <input ref={inputFileRef} type='file' accept={fileType} multiple={multiple} onChange={onFileChange} className='hidden' />
    </div>
  )
}
